export default __webpack_public_path__ + "static/media/Sui2.647663fd.JPG";